import React from "react";
import { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { normalizeError } from '@/lib/normalizeError';

export default function EnvTest() {
  const [clientEnv, setClientEnv] = useState({
    VITE_SUPABASE_URL: '',
    VITE_SUPABASE_PUBLISHABLE_KEY: '',
    exists: false
  });

  const [edgeFunctionResult, setEdgeFunctionResult] = useState<any>(null);

  useEffect(() => {
    // Test client-side env vars
    const url = import.meta.env.VITE_SUPABASE_URL;
    const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
    
    setClientEnv({
      VITE_SUPABASE_URL: url ? '✓ Accessible' : '✗ Missing',
      VITE_SUPABASE_PUBLISHABLE_KEY: key ? '✓ Accessible' : '✗ Missing',
      exists: !!url && !!key
    });

    // Test edge function env vars
    fetch(`${url}/functions/v1/health`, {
      headers: {
        'apikey': key,
      }
    })
      .then(res => res.json())
      .then(data => setEdgeFunctionResult(data))
      .catch(err => {
        const e = normalizeError(err);
        setEdgeFunctionResult({ error: e.message });
      });
  }, []);

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold">Environment Variables Test</h1>
        
        <Card className="p-6 space-y-4">
          <h2 className="text-2xl font-semibold">Client-Side (import.meta.env)</h2>
          <div className="space-y-2">
            <p><strong>VITE_SUPABASE_URL:</strong> {clientEnv.VITE_SUPABASE_URL}</p>
            <p><strong>VITE_SUPABASE_PUBLISHABLE_KEY:</strong> {clientEnv.VITE_SUPABASE_PUBLISHABLE_KEY}</p>
            <p className="text-sm text-muted-foreground">
              Status: {clientEnv.exists ? '✓ All accessible' : '✗ Missing variables'}
            </p>
          </div>
        </Card>

        <Card className="p-6 space-y-4">
          <h2 className="text-2xl font-semibold">Edge Function (Deno.env.get)</h2>
          {edgeFunctionResult ? (
            <pre className="bg-muted p-4 rounded-lg overflow-auto text-sm">
              {JSON.stringify(edgeFunctionResult, null, 2)}
            </pre>
          ) : (
            <p>Loading...</p>
          )}
        </Card>
      </div>
    </div>
  );
}
